import * as React from 'react';
import WizardCard from '../../components/WizardCard/WizardCard';
import FormField from '../../components/FormField/FormField';
import Appear from '../../components/Appear/Appear';
import Button from '../../components/Button/Button';
import classnames from 'classnames';
import LocationInput from '../../components/LocationInput/LocationInput';
import YesNoBtns from '../../components/YesNoBtns/YesNoBtns';
import withContainer from '../../containers/WithContainer';
import { withRouter } from 'react-router-dom';

interface HomeStudioState {
  hasHomeStudio: boolean;
  state: string;
  suburb: string;
  formattedAddress: string;
  postcode: string;
  country: string;
  street: string;
  apt: string;
}

class HomeStudio extends React.Component<any, HomeStudioState> {
  constructor(props) {
    super(props);
    this.state = {
      hasHomeStudio: false,
      state: '',
      suburb: '',
      country: '',
      postcode: '',
      formattedAddress: '',
      apt: '',
      street: '',
    };
  }

  app = this.props.appContainer;
  handleLoationChange = address => {
    this.setState({ ...address });
  };

  handleInputChange = evt => {
    const {
      target: { name, value },
    } = evt;
    this.setState({ ...this.state, ...{ [name]: value } });
  };
  onNext = async () => {
    this.props.appContainer.step6update(this.getCurrStep());
  };
  onNo = async () => {
    this.app.setHomeSelection('no');
    //    this.props.appContainer.setHomeStudioStatus(0);
  };
  onYes = () => {
    this.app.setHomeSelection('yes');
    this.setState({ hasHomeStudio: true });
  };

  getCurrStep = () => {
    let step = parseInt(this.props.match.path.split('-')[1]);
    return step;
  };
  public render() {
    let selected;
    if (this.app.state.homeSelection === 'yes') {
      selected = 'yes';
    } else if (this.app.state.homeSelection === 'no') {
      selected = 'no';
    } else {
      selected = '';
    }
    const {
      hasHomeStudio,
      apt,
      state,
      suburb,
      country,
      postcode,
      formattedAddress,
      street,
    } = this.state;
    return (
      <WizardCard
        title="What's your home studio location?"
        subTitle={
          <div>
            Let customers come to you. <br /> Your full address is only shown to
            customers who book you.
          </div>
        }
        delay={1.6}
        isDisabled={
          !this.props.appContainer.state.step7.home_studio_address
            .street_address
        }
        onNext={this.onNext}
      >
        <div>
          <FormField label="Home Studio Address" htmlFor="location" required>
            <LocationInput
              address={{
                state,
                street,
                suburb,
                country,
                postcode,
                formattedAddress,
              }}
              onChange={this.handleLoationChange}
              app={this.props.appContainer}
            />
          </FormField>
          {!!true && (
            <Appear>
              {/* apt */}
              <FormField label="Apartment (if applicable)" htmlFor="apt">
                <input
                  type="text"
                  className="input"
                  id="apt"
                  placeholder="Enter your unit/apartment"
                  name="apartment"
                  value={
                    this.props.appContainer.state.step7.home_studio_address
                      .apartment
                  }
                  onChange={this.props.appContainer.onStep7fieldChange}
                />
              </FormField>

              {/* street */}
              <FormField label="Street address" htmlFor="street" required>
                <input
                  type="text"
                  className="input"
                  id="street"
                  placeholder="Enter your street"
                  name="street_address"
                  value={
                    this.props.appContainer.state.step7.home_studio_address
                      .street_address
                  }
                  onChange={this.props.appContainer.onStep7fieldChange}
                />
              </FormField>

              {/* suburb */}
              {/* <FormField
                label="Suburb"
                htmlFor="suburb"
                required
                iconLeft={<i className="fas fa-map-marked-alt" />}
              >
                <input
                  type="text"
                  className="input"
                  id="suburb"
                  placeholder="Enter your suburb"
                  name="suburb"
                  value={suburb}
                  onChange={this.handleInputChange}
                  disabled
                />
              </FormField> */}

              {/* state */}
              {/* <FormField
                label="state"
                htmlFor="state"
                required
                iconLeft={<i className="fas fa-map-pin" />}
              >
                <input
                  type="text"
                  className="input"
                  id="state"
                  placeholder="Enter your state"
                  name="state"
                  value={state}
                  onChange={this.handleInputChange}
                  disabled
                />
              </FormField> */}

              {/* postcode */}
              {/* <FormField
                label="post code"
                htmlFor="postcode"
                required
                iconLeft={<i className="fas fa-hashtag" />}
              >
                <input
                  type="text"
                  className="input"
                  id="postcode"
                  placeholder="Enter your post code"
                  name="postcode"
                  value={postcode}
                  onChange={this.handleInputChange}
                  disabled
                />
              </FormField> */}

              {/* country */}
              {/* <FormField
                label="country"
                htmlFor="country"
                required
                iconLeft={<i className="fas fa-globe" />}
              >
                <input
                  type="text"
                  className="input"
                  id="country"
                  placeholder="Enter your country"
                  name="country"
                  value={country}
                  onChange={this.handleInputChange}
                  disabled
                />
              </FormField> */}
            </Appear>
          )}

          <p className="has-text-centered has-text-info has-margin-top-5">
            A postcard will be sent to this address for verification.
          </p>
        </div>
      </WizardCard>
    );
  }
}

export default withRouter(withContainer(HomeStudio));
